import * as angular from "angular";
import { ApiUserService } from "../../services/user.service";
import { DialogUtils } from "../../helper/dialog.helper";

let UserTermsConditionsComponent = {
    selector: "vcUserTermsConditions",
    templateUrl:
        "/angular/components/user/user-terms-conditions.component.html",
    bindings: {
        uid: "=",
    },
    controller: class UserTermsConditionsController {
        // * bindings for typescript compiler *
        public uid: any;
        // ************************************

        public __env: any;
        private dialog: DialogUtils;
        private apiUserService: ApiUserService;

        public version?: any;
        public host?: any;

        constructor(
            __env: any,
            DialogUtils: DialogUtils,
            ApiUserService: ApiUserService
        ) {
            this.dialog = DialogUtils;
            this.apiUserService = ApiUserService;
            this.__env = __env;
            this.version = this.__env.terms_conditions_version;
            this.host = this.__env.host;
        }

        accept(): void {
            this.apiUserService.updateTerms({
                uid: this.uid,
                termsconditionsversion: this.version,
            });
            this.dialog.hide();
        }
    },
};

angular
    .module("user")
    .component(
        UserTermsConditionsComponent.selector,
        UserTermsConditionsComponent
    );
